export default "__VITE_ASSET__DMP0JnLK__"